import FieldConfig from "../../../proto/field-config"
import FieldsCollection from "../../../collection/base/fields-collection"

import FieldSelectGroupField_ControlView from "./render/control-view"
import FieldSelectField from "../select-field/select-field"
import FieldSelectGroupField_Popover from "./components/popover/popover"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import FieldSelectGroupField_FormValueNotEmpty from "./components/form/value-not-empty"

export default class FieldSelectGroupField extends FieldSelectField {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Select group field"

        this.fields                         = _.get(config, 'fields', new FieldsCollection([]))
        this.fieldsStructure                = _.get(config, 'fieldsStructure', [])

        this.noValueOption                  = _.get(config, 'noValueOption', true)
        this.noValueOptionIcon              = _.get(config, 'noValueOptionIcon', 'i5-none')
        this.noValueOptionLabel             = _.get(config, 'noValueOptionLabel', 'No grouping')

        this.components.PopoverMenu         = FieldSelectGroupField_Popover
        this.components.FormValueNotEmpty   = FieldSelectGroupField_FormValueNotEmpty

        this.renderComponents.controlView   = FieldSelectGroupField_ControlView
    }

    getViewValue(model: any): GroupBy {
        return super.getViewValue(model) as GroupBy;
    }
}